import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  MenuItem,
  Box,
} from '@mui/material';
import Modal from '../../../../components/Modal';
import Form from '../../../../components/useForm';
import { Controls } from '../../../../components/controls/Controls';
import TelusCalendarTable from './TelusCalendarTable';

export default function TelusCalendarConfigurationModal(props) {
  const {
    isOpen,
    handleClose,
    setting,
    handleSave,
    calendars,
    contacts,
  } = props;

  const [selectedCalendars, setSelectedCalendars] = useState(
    setting.value ? JSON.parse(setting.value) : [],
  );
  const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [error, setError] = useState('');

  const handleCalendarAddition = () => {
    if (!selectedCalendar) {
      setError('Please select a calendar');
      return;
    }
    if (selectedCalendars.find(
      (cal) => cal.id === selectedCalendar.id,
    )) {
      setError('Calendar already exists');
      return;
    }

    // Find matching provider/contact by scheduleId
    const matchingProvider = contacts?.find(
      (contact) => contact.userDetail?.defaultScheduleId === selectedCalendar.id,
    );

    setError('');
    setSelectedCalendars(
      [
        ...selectedCalendars,
        {
          id: selectedCalendar.id,
          name: selectedCalendar.name,
          provider: matchingProvider || null,
          sendNotification: true,
        },
      ],
    );
    setSelectedCalendar(null);
  };

  const handleSaveChanges = () => {
    handleSave(setting, JSON.stringify(selectedCalendars));
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Calendar Configuration"
      size="md"
    >
      <Form>
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={8}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Controls.Select
                fullWidth
                name="calendar"
                label="Calendar"
                value={selectedCalendar}
                onChange={(event) => {
                  setSelectedCalendar(event.target.value);
                  setError('');
                }}
                renderValue={(value) => value?.name || ''}
                error={error}
              >
                {calendars.map((calendar) => (
                  <MenuItem key={calendar.id} value={calendar}>
                    {calendar.name}
                  </MenuItem>
                ))}
              </Controls.Select>
              <Controls.Button
                text="Add"
                onClick={handleCalendarAddition}
                sx={{ minWidth: '100px', height: '56px' }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Controls.Button
              text="Save"
              onClick={handleSaveChanges}
              sx={{ minWidth: '100px', height: '56px' }}
            />
          </Grid>
        </Grid>
        <TelusCalendarTable
          calendars={selectedCalendars}
          setCalendars={setSelectedCalendars}
        />
      </Form>
    </Modal>
  );
}

TelusCalendarConfigurationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  handleSave: PropTypes.func.isRequired,
  calendars: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      userDetail: PropTypes.shape({
        providerId: PropTypes.string.isRequired,
        defaultScheduleId: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      type: PropTypes.string,
      canReceiveMessage: PropTypes.bool.isRequired,
      services: PropTypes.arrayOf(PropTypes.string),
      id: PropTypes.string.isRequired,
      descriptor: PropTypes.string,
    }),
  ),
};

TelusCalendarConfigurationModal.defaultProps = {
  contacts: [],
};
